import { Observable, of } from 'rxjs';
import { catchError, filter, first, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';

import { AppState } from '../../core.state';
import { LoadPublicHealthRecordTypes } from './store/public-health-record-type.actions';
import { selectPublicHealthRecordTypesLoaded } from './store/public-health-record-type.selectors';

@Injectable({
  providedIn: 'root'
})
export class PublicHealthRecordTypeListGuard implements CanActivate {
  constructor(private store: Store<AppState>) { }

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(selectPublicHealthRecordTypesLoaded).pipe(
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(new LoadPublicHealthRecordTypes());
        }
      }),
      filter(loaded => loaded),
      first()
    );
  }
}
